import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { bindSearchAutocomplete, noResultHtml } from "../../common/autocomplete";
import { reloadDatatable, setHighlightedRow, highlightRow } from "../../common/datatables";
import { openSnackbar, snackbarModel } from "../../common/snackbar";
import forms from "../../common/forms"

const props = {
    adminProductDynamicDataManagementMarker: '#marker-product-dynamic-data-management',
    productId: '#ProductId',
    modalPlaceholder: '#popup-placeholder',

    //CORE BENEFITS
    coreBenefitsAc: '#search-core-benefits',
    coreBenefitsDatatable: '#dt-product-core-benefit-management',
    coreBenefitsUp: '.core-benefit-move-up',
    coreBenefitsDown: '.core-benefit-move-down',
    coreBenefitsRemove: '.core-benefit-remove',

    //FEATURED BENEFITS
    featuredBenefitsAc: '#search-featured-benefits',
    featuredBenefitsDatatable: '#dt-product-featured-benefit-management',
    featuredBenefitsUp: '.featured-benefit-move-up',
    featuredBenefitsDown: '.featured-benefit-move-down',
    featuredBenefitsRemove: '.featured-benefit-remove',

    //ADDITIONAL BENEFITS
    additionalBenefitsDatatable: '#dt-product-additional-benefit-management',
    additionalBenefitsUp: '.additional-benefit-move-up',
    additionalBenefitsDown: '.additional-benefit-move-down',
    additionalBenefitsRemove: '.additional-benefit-remove',
    additionalBenefitsModal: '#edit-product-additional-benefit-modal',
    additionalBenefitsModalErrorMessage: '#edit-product-additional-benefit-error-message',

    //ADDITIONAL BENEFITS
    specificationItemsDatatable: '#dt-product-specification-item-management',
    specificationItemsRemove: '.specification-item-remove',
    specificationItemsModal: '#edit-product-specification-item-modal',
    specificationItemsModalErrorMessage: '#edit-product-specification-item-error-message'
};

export function initProductDynamicDataManagement() {

    if ($(props.adminProductDynamicDataManagementMarker).length) {

        initialiseCoreBenefits(); 
        initialiseFeaturedBenefits();
        initialiseAdditionalBenefits();
        initialiseSpecificationItems();
    }

}

//START - CORE BENEFIT FUNCTIONS
function initialiseCoreBenefits() {

    dtAdminCoreBenefitsManagement(initCoreBenefitDatatableEvents);
    initCoreBenefitSearchAutoComplete();
}

async function initCoreBenefitSearchAutoComplete() {

    catchError(async function () {

        const containerId = '#search-core-benefits';
        const autoComplete = `${containerId} .search-autocomplete`;

        bindSearchAutocomplete(containerId, async function (outputSearchTerm) {

            const data = {
                productId: $(props.productId).val(),
                filter: outputSearchTerm,
                featuredBenefitType: 'CORE_PRODUCT_BENEFITS'
            };

            const result = await getSearchFeaturedBenefitsAutocompleteHtml(data);
            const isDataEmpty = isEmpty(result);

            if (isDataEmpty) return injectHtml(autoComplete, noResultHtml);

            await injectHtml(autoComplete, result);

            $(autoComplete).find('.autocomplete-item').off('click').on('click', async function (e) {

                //post back, saving the selected benefit against the product. reload the relevant table when complete.
                const benefitId = $(this).data('id');

                const productBenefitData = {
                    productId: $(props.productId).val(),
                    featuredBenefitId: benefitId
                };

                await createProductFeaturedBenefitService(productBenefitData);

                reloadCoreBenefitManagementDatatable();

                //display confirmation message to the user
                openSnackbar({
                    ...snackbarModel,
                    content: 'Core Benefit Item added.'
                });
            });
        });
    });
}

const reloadCoreBenefitManagementDatatable = () => {
    //PURPOSE: reloads core benefit management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.coreBenefitsDatatable, initCoreBenefitDatatableEvents, true);
};

function initCoreBenefitDatatableEvents() {

    //bind any events related to the loaded datatable
    bindCoreBenefitTableEvents();

    //a row is intended to be highlighted briefly. find it by id, then highlight by adding and removing a class.
    //if the 'highlight id' is not set then no action is taken
    highlightRow(props.coreBenefitsDatatable);
}


function dtAdminCoreBenefitsManagement(onloadCallback) {

    if ($(props.coreBenefitsDatatable).length === 0) return false;

    $(props.coreBenefitsDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: false,
        info: false,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/productdynamicdata/productfeaturedbenefitsearch',
            data: function (d) {
                d.productId = $(props.productId).val();
                d.featuredBenefitType = 'CORE_PRODUCT_BENEFITS';

            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'title', name: 'Title' },
            { data: 'index', name: 'Index' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<i class="material-icons mdc-icon-button core-benefit-index-change core-benefit-move-up mr-2">arrow_circle_up</i><i class="material-icons mdc-icon-button core-benefit-index-change core-benefit-move-down">arrow_circle_down</i>'
                },
                class: 'text-align-center'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="core-benefit-remove mdc-button mdc-button--raised bg-red text-white min-width-100 mr-2">Remove</div>'
                },
                class: 'text-align-right'
            },
        ],

        //sort by index
        order: [[1, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

function bindCoreBenefitTableEvents() {

    $('.core-benefit-index-change').off('click').on('click', async function (e) {

        //ascertain whether the move up or down button was clicked
        var moveUp = true;

        if ($(this).hasClass('core-benefit-move-down')) {

            moveUp = false;
        }

        var pfbId = $(e.currentTarget).closest('tr').data('id');

        //set highlighted item so that the row is briefly 'highlighted' once the change is complete
        setHighlightedRow(pfbId);

        const productBenefitData = {
            itemId: pfbId,
            moveUp: moveUp
        };

        await changeProductFeaturedBenefitIndexService(productBenefitData);

        reloadCoreBenefitManagementDatatable();
    });

    $('.core-benefit-remove').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var pfbId = $(e.currentTarget).closest('tr').data('id');

        const productBenefitData = {
            productFeaturedBenefitId: pfbId
        };

        await removeProductFeaturedBenefitService(productBenefitData);

        reloadCoreBenefitManagementDatatable();

        //display confirmation message to the user
        openSnackbar({
            ...snackbarModel,
            content: 'Item removed.'
        });
    });
}
//END - CORE BENEFIT FUNCTIONS

//START - FEATURES AND BENEFITS FUNCTIONS
function initialiseFeaturedBenefits() {

    dtAdminFeaturedBenefitsManagement(initFeaturedBenefitDatatableEvents);
    initFeaturedBenefitSearchAutoComplete();
}

async function initFeaturedBenefitSearchAutoComplete() {

    catchError(async function () {

        const containerId = '#search-featured-benefits';
        const autoComplete = `${containerId} .search-autocomplete`;

        bindSearchAutocomplete(containerId, async function (outputSearchTerm) {

            const data = {
                productId: $(props.productId).val(),
                filter: outputSearchTerm,
                featuredBenefitType: 'FEATURES_AND_BENEFITS'
            };

            const result = await getSearchFeaturedBenefitsAutocompleteHtml(data);
            const isDataEmpty = isEmpty(result);

            if (isDataEmpty) return injectHtml(autoComplete, noResultHtml);

            await injectHtml(autoComplete, result);

            $(autoComplete).find('.autocomplete-item').off('click').on('click', async function (e) {

                //post back, saving the selected benefit against the product. reload the relevant table when complete.
                const benefitId = $(this).data('id');

                const productBenefitData = {
                    productId: $(props.productId).val(),
                    featuredBenefitId: benefitId
                };

                await createProductFeaturedBenefitService(productBenefitData);

                reloadFeaturedBenefitManagementDatatable();

                //display confirmation message to the user
                openSnackbar({
                    ...snackbarModel,
                    content: 'Features & Benefits Item added.'
                });
            });
        });
    });
}

const reloadFeaturedBenefitManagementDatatable = () => {
    //PURPOSE: reloads featured benefit management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.featuredBenefitsDatatable, initFeaturedBenefitDatatableEvents, true);
};

function initFeaturedBenefitDatatableEvents() {

    //bind any events related to the loaded datatable
    bindFeaturedBenefitTableEvents();

    //a row is intended to be highlighted briefly. find it by id, then highlight by adding and removing a class.
    //if the 'highlight id' is not set then no action is taken
    highlightRow(props.featuredBenefitsDatatable);
}


function dtAdminFeaturedBenefitsManagement(onloadCallback) {

    if ($(props.featuredBenefitsDatatable).length === 0) return false;

    $(props.featuredBenefitsDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: false,
        info: false,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/productdynamicdata/productfeaturedbenefitsearch',
            data: function (d) {
                d.productId = $(props.productId).val();
                d.featuredBenefitType = 'FEATURES_AND_BENEFITS';

            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'title', name: 'Title' },
            { data: 'index', name: 'Index' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<i class="material-icons mdc-icon-button featured-benefit-index-change featured-benefit-move-up mr-2">arrow_circle_up</i><i class="material-icons mdc-icon-button featured-benefit-index-change featured-benefit-move-down">arrow_circle_down</i>'
                },
                class: 'text-align-center'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="featured-benefit-remove mdc-button mdc-button--raised bg-red text-white min-width-100 mr-2">Remove</div>'
                },
                class: 'text-align-right'
            },
        ],

        //sort by index
        order: [[1, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

function bindFeaturedBenefitTableEvents() {

    $('.featured-benefit-index-change').off('click').on('click', async function (e) {

        //ascertain whether the move up or down button was clicked
        var moveUp = true;

        if ($(this).hasClass('featured-benefit-move-down')) {

            moveUp = false;
        }

        var pfbId = $(e.currentTarget).closest('tr').data('id');

        //set highlighted item so that the row is briefly 'highlighted' once the change is complete
        setHighlightedRow(pfbId);

        const productBenefitData = {
            itemId: pfbId,
            moveUp: moveUp
        };

        await changeProductFeaturedBenefitIndexService(productBenefitData);

        reloadFeaturedBenefitManagementDatatable();
    });

    $('.featured-benefit-remove').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var pfbId = $(e.currentTarget).closest('tr').data('id');

        const productBenefitData = {
            productFeaturedBenefitId: pfbId
        };

        await removeProductFeaturedBenefitService(productBenefitData);

        reloadFeaturedBenefitManagementDatatable();

        //display confirmation message to the user
        openSnackbar({
            ...snackbarModel,
            content: 'Item removed.'
        });
    });
}

//END - FEATURES AND BENEFITS FUNCTIONS


//START - ADDITIONAL BENEFITS FUNCTIONS
function initialiseAdditionalBenefits() {

    dtAdminAdditionalBenefitsManagement(initAdditionalBenefitDatatableEvents);

}


const reloadAdditionalBenefitManagementDatatable = () => {
    //PURPOSE: reloads featured benefit management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.additionalBenefitsDatatable, initAdditionalBenefitDatatableEvents, true);
};

function initAdditionalBenefitDatatableEvents() {

    //bind any events related to the loaded datatable
    bindAdditionalBenefitTableEvents();

    //a row is intended to be highlighted briefly. find it by id, then highlight by adding and removing a class.
    //if the 'highlight id' is not set then no action is taken
    highlightRow(props.additionalBenefitsDatatable);
}


function dtAdminAdditionalBenefitsManagement(onloadCallback) {

    if ($(props.additionalBenefitsDatatable).length === 0) return false;

    $(props.additionalBenefitsDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: false,
        info: false,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/productdynamicdata/productadditionalbenefitsearch',
            data: function (d) {
                d.productId = $(props.productId).val();
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'content', name: 'Content' },
            { data: 'contentType', name: 'Content Type' },
            { data: 'index', name: 'Index' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<i class="material-icons mdc-icon-button additional-benefit-index-change additional-benefit-move-up mr-2">arrow_circle_up</i><i class="material-icons mdc-icon-button additional-benefit-index-change additional-benefit-move-down">arrow_circle_down</i>'
                },
                class: 'text-align-center'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="additional-benefit-edit mdc-button mdc-button--raised text-white min-width-100 mr-2">Edit</div>'
                },
                class: 'text-align-center'
            },            
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="additional-benefit-remove mdc-button mdc-button--raised bg-red text-white min-width-100 mr-2">Remove</div>'
                },
                class: 'text-align-right'
            }
        ],

        //sort by index
        order: [[2, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

function bindAdditionalBenefitTableEvents() {

    $('.additional-benefit-index-change').off('click').on('click', async function (e) {

        //ascertain whether the move up or down button was clicked
        var moveUp = true;

        if ($(this).hasClass('additional-benefit-move-down')) {

            moveUp = false;
        }

        var pabId = $(e.currentTarget).closest('tr').data('id');

        //set highlighted item so that the row is briefly 'highlighted' once the change is complete
        setHighlightedRow(pabId);

        const additionalBenefitData = {
            itemId: pabId,
            moveUp: moveUp
        };

        await changeProductAdditionalBenefitIndexService(additionalBenefitData);

        reloadAdditionalBenefitManagementDatatable();
    });


    $('#additional-benefit-add').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        const data = {
            productId: $(props.productId).val()
        };

        const result = await getProductAdditionalBenefitHtml(data);

        await injectHtml(props.modalPlaceholder, result);

        //bind 'modal on shown' events
        await initEditProductAdditionalBenefitModalOnShow();

        //launch modal
        $(props.additionalBenefitsModal).modal('show');
    });

    $('.additional-benefit-edit').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var pabId = $(e.currentTarget).closest('tr').data('id');

        const data = {
            productId: $(props.productId).val(),
            id: pabId
        };

        const result = await getProductAdditionalBenefitHtml(data);

        await injectHtml(props.modalPlaceholder, result);

        //bind 'modal on shown' events
        await initEditProductAdditionalBenefitModalOnShow();

        //launch modal
        $(props.additionalBenefitsModal).modal('show');
    });

    $('.additional-benefit-remove').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var pabId = $(e.currentTarget).closest('tr').data('id');

        const additionalBenefitData = {
            productAdditionalBenefitId: pabId
        };

        await removeProductAdditionalBenefitService(additionalBenefitData);

        reloadAdditionalBenefitManagementDatatable();

        //display confirmation message to the user
        openSnackbar({
            ...snackbarModel,
            content: 'Item removed.'
        });
    });
}


async function initEditProductAdditionalBenefitModalOnShow() {

    catchError(async function () {

        //when the 'ad / edit po line' modal is shown bind all relevant events
        $(props.additionalBenefitsModal).off('shown.bs.modal').on('shown.bs.modal', async function (e) {

            tinymce.remove("#CustomContent");

            tinymce.init({
                selector: '#CustomContent',
                plugins:
                    'advlist anchor autolink charmap code codesample fullscreen image link lists paste searchreplace table help',
                toolbar:
                    'bold italic underline forecolor | ' +
                    'bullist numlist | fullscreen | ' +
                    'table link codesample charmap | ' +
                    'alignleft aligncenter alignright alignjustify ' +
                    'help',
                menu: {
                    file: {
                        title: 'File',
                        items: ''
                    },
                    edit: {
                        title: 'Edit',
                        items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
                    },
                    view: {
                        title: 'View',
                        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
                    },
                    insert: {
                        title: 'Insert',
                        items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
                    },
                    format: {
                        title: 'Format',
                        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
                    },
                    tools: {
                        title: 'Tools',
                        items: ''
                    },
                    table: {
                        title: 'Table',
                        items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
                    },
                    help: {
                        title: 'Help',
                        items: 'help'
                    }
                },
                force_p_newlines: false,
                forced_root_block: '',
                //For more styles use content_css (see the docs)
                content_style: "body { font-size: 14px; }",
                height: 480
            });


            //bind submit event for form
            initSubmitEditProductAdditionalBenefitEvents();
        })
    });
}


function initSubmitEditProductAdditionalBenefitEvents() {

    catchError(async function () {

        const formObject = $('#edit-product-additional-benefit-form');
        const save_button_selector = $('#edit-product-additional-benefit-submit');

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(save_button_selector).off('click').on('click', async function () {

                //validate form
                if (formObject.valid()) {

                    var tinymceCustomContent = tinymce.get("CustomContent").getContent();

                    //manual validation - has either a featured benefit been selected or content provided?
                    if (isEmpty(tinymceCustomContent) && isEmpty($('#FeaturedBenefitId').val()) ) {

                        $(props.additionalBenefitsModalErrorMessage).html('Either a Featured Benefit must be selected or custom content be provided for this Additional Benefit.');
                        $(props.additionalBenefitsModalErrorMessage).show();
                        return;
                    }

                    //manually assign tinymce content or it is not serialized
                    $('#CustomContent').val(tinymceCustomContent);

                    const parent = $(props.additionalBenefitsModal);

                    const activityIndicator = parent.find('.submit-activity');

                    activityIndicator.show().css("display", "inline-block");

                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        const formValues = formObject.serialize();

                        //attempt POST save, the check response
                        const response = await editProductAdditionalBenefitPostService(formValues);

                        if (response.responseType === "SUCCESS") {

                            $(props.additionalBenefitsModal).modal('hide');

                            reloadAdditionalBenefitManagementDatatable();

                            //display confirmation message to the user
                            openSnackbar({
                                ...snackbarModel,
                                content: 'Product Additional Benefit item updated.'
                            });
                        }
                        else {


                            $(props.additionalBenefitsModalErrorMessage).html(response.responseMessage);

                            $(props.additionalBenefitsModalErrorMessage).show(500);
                        }

                        forms.formUnderSubmission(false);

                    }, 1000);
                } else {

                    //no scroll to in modal
                    //app.forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}

//END - ADDITIONAL BENEFITS FUNCTIONS


//START - SPECIFICATION ITEM FUNCTIONS
function initialiseSpecificationItems() {

    dtAdminSpecificationItemsManagement(initSpecificationItemDatatableEvents);

}


const reloadSpecificationItemManagementDatatable = () => {
    //PURPOSE: reloads featured benefit management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.specificationItemsDatatable, initSpecificationItemDatatableEvents, true);
};

function initSpecificationItemDatatableEvents() {

    //bind any events related to the loaded datatable
    bindSpecificationItemTableEvents();

    //a row is intended to be highlighted briefly. find it by id, then highlight by adding and removing a class.
    //if the 'highlight id' is not set then no action is taken
    highlightRow(props.specificationItemsDatatable);
}


function dtAdminSpecificationItemsManagement(onloadCallback) {

    if ($(props.specificationItemsDatatable).length === 0) return false;

    $(props.specificationItemsDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: false,
        info: false,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/productdynamicdata/productspecificationitemsearch',
            data: function (d) {
                d.productId = $(props.productId).val();
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'index', name: 'Index', visible: false },
            { data: 'specificationTitle', name: 'Specification' },
            { data: 'specificationValue', name: 'Value' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="specification-item-edit mdc-button mdc-button--raised text-white min-width-100 mr-2">Edit</div>'
                },
                class: 'text-align-center'
            },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="specification-item-remove mdc-button mdc-button--raised bg-red text-white min-width-100 mr-2">Remove</div>'
                },
                class: 'text-align-right'
            }
        ],

        //sort by index
        order: [[0, "asc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}

function bindSpecificationItemTableEvents() {

    $('#specification-item-add').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        const data = {
            productId: $(props.productId).val()
        };

        const result = await getProductSpecificationItemHtml(data);

        await injectHtml(props.modalPlaceholder, result);

        //bind 'modal on shown' events
        await initEditProductSpecificationItemModalOnShow();

        //launch modal
        $(props.specificationItemsModal).modal('show');
    });

    $('.specification-item-edit').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var pabId = $(e.currentTarget).closest('tr').data('id');

        const data = {
            productId: $(props.productId).val(),
            id: pabId
        };

        const result = await getProductSpecificationItemHtml(data);

        await injectHtml(props.modalPlaceholder, result);

        //bind 'modal on shown' events
        await initEditProductSpecificationItemModalOnShow();

        //launch modal
        $(props.specificationItemsModal).modal('show');
    });

    $('.specification-item-remove').off('click').on('click', async function (e) {

        //called when the 'remove' button is clicked 
        var psiId = $(e.currentTarget).closest('tr').data('id');

        const additionalBenefitData = {
            productSpecificationItemId: psiId
        };

        await removeProductSpecificationItemService(additionalBenefitData);

        reloadSpecificationItemManagementDatatable();

        //display confirmation message to the user
        openSnackbar({
            ...snackbarModel,
            content: 'Item removed.'
        });
    });
}


async function initEditProductSpecificationItemModalOnShow() {

    catchError(async function () {

        //when the 'ad / edit po line' modal is shown bind all relevant events
        $(props.specificationItemsModal).off('shown.bs.modal').on('shown.bs.modal', async function (e) {

            tinymce.remove("#SpecificationContent");

            tinymce.init({
                selector: '#SpecificationContent',
                plugins:
                    'advlist anchor autolink charmap code codesample fullscreen image link lists paste searchreplace table help',
                toolbar:
                    'bold italic underline forecolor | ' +
                    'bullist numlist | fullscreen | ' +
                    'table link codesample charmap | ' +
                    'alignleft aligncenter alignright alignjustify ' +
                    'help',
                menu: {
                    file: {
                        title: 'File',
                        items: ''
                    },
                    edit: {
                        title: 'Edit',
                        items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
                    },
                    view: {
                        title: 'View',
                        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
                    },
                    insert: {
                        title: 'Insert',
                        items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
                    },
                    format: {
                        title: 'Format',
                        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
                    },
                    tools: {
                        title: 'Tools',
                        items: ''
                    },
                    table: {
                        title: 'Table',
                        items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
                    },
                    help: {
                        title: 'Help',
                        items: 'help'
                    }
                },
                force_p_newlines: false,
                forced_root_block: '',
                //For more styles use content_css (see the docs)
                content_style: "body { font-size: 14px; }",
                height: 480
            });


            //bind submit event for form
            initSubmitEditProductSpecificationItemEvents();
        })
    });
}


function initSubmitEditProductSpecificationItemEvents() {

    catchError(async function () {

        const formObject = $('#edit-product-specification-item-form');
        const save_button_selector = $('#edit-product-specification-item-submit');

        //only attempt validation / binding if the form is present
        if (formObject.length > 0) {

            //initialise jquery validation for the injected form
            const validator = forms.onloadValidationSetupByObject(formObject);

            $(save_button_selector).off('click').on('click', async function () {

                //validate form
                if (formObject.valid()) {

                    var tinymceCustomContent = tinymce.get("SpecificationContent").getContent();

                    //manual validation - has content provided?
                    if (isEmpty(tinymceCustomContent)) {

                        $(props.additionalBenefitsModalErrorMessage).html('Content be provided for this Specification Item.');
                        $(props.additionalBenefitsModalErrorMessage).show();
                        return;
                    }

                    //manually assign tinymce content or it is not serialized
                    $('#SpecificationContent').val(tinymceCustomContent);

                    const parent = $(props.specificationItemsModal);

                    const activityIndicator = parent.find('.submit-activity');

                    activityIndicator.show().css("display", "inline-block");

                    forms.formUnderSubmission(true);

                    setTimeout(async function () {

                        const formValues = formObject.serialize();

                        //attempt POST save, the check response
                        const response = await editProductSpecificationItemPostService(formValues);

                        if (response.responseType === "SUCCESS") {

                            $(props.specificationItemsModal).modal('hide');

                            reloadSpecificationItemManagementDatatable();

                            //display confirmation message to the user
                            openSnackbar({
                                ...snackbarModel,
                                content: 'Product Specification Item updated.'
                            });
                        }
                        else {


                            $(props.specificationItemsModalErrorMessage).html(response.responseMessage);

                            $(props.specificationItemsModalErrorMessage).show(500);
                        }

                        forms.formUnderSubmission(false);

                    }, 1000);
                } else {

                    //no scroll to in modal
                    //app.forms.scrollToFirstError(validator, $(document).height() * 0.5);
                }
            });
        }
    });
}

//END - SPECIFICATION ITEM FUNCTIONS

//API CALLS

async function getSearchFeaturedBenefitsAutocompleteHtml(data) {

    //no TRY CATCH as handled by parent
    //returns a list of results for the core benefits autocomplete
    //used by both core benefits and featured benefits management functions
    const response = await http.get('/administration/productdynamicdata/searchfeaturedbenefits', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function createProductFeaturedBenefitService(data) {

    //no TRY CATCH as handled by parent
    //create a Product Featured Benefit item
    const response = await http.post('/administration/productdynamicdata/createproductfeaturedbenefit', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function changeProductFeaturedBenefitIndexService(data) {

    //no TRY CATCH as handled by parent
    //chanegs the index of a current product featured benefit item. can be used by both Core Benefits and Featured Benefits
    const response = await http.post('/administration/productdynamicdata/changeproductfeaturedbenefitindex', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function removeProductFeaturedBenefitService(data) {

    //no TRY CATCH as handled by parent
    //removes the selected benefit from the product. can be used by both Core Benefits and Featured Benefits
    const response = await http.post('/administration/productdynamicdata/removeproductfeaturedbenefit', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

//ADDITIONAL BENEFITS API CALLS
async function changeProductAdditionalBenefitIndexService(data) {

    //no TRY CATCH as handled by parent
    //chanegs the index of a current product featured benefit item. can be used by both Core Benefits and Featured Benefits
    const response = await http.post('/administration/productdynamicdata/changeproductadditionalbenefitindex', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function removeProductAdditionalBenefitService(data) {

    //no TRY CATCH as handled by parent
    //removes the selected benefit from the product. can be used by both Core Benefits and Featured Benefits
    const response = await http.post('/administration/productdynamicdata/removeproductadditionalbenefit', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function getProductAdditionalBenefitHtml(data) {

    //no TRY CATCH as handled by parent
    //returns a list of results for the core benefits autocomplete
    //used by both core benefits and featured benefits management functions
    const response = await http.get('/administration/productdynamicdata/buildeditproductadditionalbenefitmodal', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function editProductAdditionalBenefitPostService(data) {

    //no TRY CATCH as handled by parent
    //removes the selected benefit from the product. can be used by both Core Benefits and Featured Benefits
    const response = await http.post('/administration/productdynamicdata/editproductadditionalbenefitpost', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

//SPECIFICATION ITEMS API CALLS
async function removeProductSpecificationItemService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productdynamicdata/removeproductspecificationitem', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}

async function getProductSpecificationItemHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.get('/administration/productdynamicdata/buildeditproductspecificationitemmodal', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function editProductSpecificationItemPostService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productdynamicdata/editproductspecificationitempost', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}